export default {
    en: {
        form: {
            labels: {
                firstName: 'First name',
                lastName: 'Last name',
                email: 'Email',
                phoneNumber: 'Phone number',
            },
        },
        generic: {
            ok: 'Ok',
            save: 'Save',
            add: 'Add',
            cancel: 'Cancel',
            loading: 'Loading...',
            seconds_ago: 'A second ago | {count} seconds ago',
            seconds: 'One second | {count} seconds',
        },
        router: {
            dashboard: 'Dashboard',
            settings: 'Settings',
            features: 'Features & Apps',
            keywordMonitoring: 'Keyword Monitoring',
            save: 'Save',
        },
        errors: {
            somethingWentWrong: 'Something went wrong...',
            networkErrorTitle: 'Oh no...',
            networkError:
                'Could not reach the server. Please check your Internet connection and try again.',
            somethingWentWrongCode:
                'Something went wrong, please try again later (code {code}).',
            too_many_requests:
                'Too many requests, please wait a bit and try again.',
        },
    },

    es: {
        form: {
            labels: {
                firstName: 'Nombre',
                lastName: 'Apellido',
                email: 'Correo electrónico',
                phoneNumber: 'Teléfono',
            },
        },
        generic: {
            ok: 'vale',
            save: 'Guardar',
            add: 'Añadir',
            cancel: 'Cancelar',
        },
        router: {
            dashboard: 'Escritorio',
            settings: 'Ajustes',
            save: 'Guardar',
            features: 'Funciones & aplicaciones',
            keywordMonitoring: 'Palabras clave de Monitoreo',
        },
        errors: {
            somethingWentWrong: 'Lo sentimos, algo salió mal...',
            networkErrorTitle: 'Oh no...',
            networkError:
                'No se pudo acceder al servidor. Comprueba tu conexión a Internet y vuelve a intentarlo..',
            somethingWentWrongCode:
                'Algo salió mal. Vuelve a intentarlo más tarde.(code {code}).',
            too_many_requests:
                '§§Too many requests, please wait a bit and try again.',
        },
    },
};
